import './TopBar.css'
import { AiFillPhone, AiTwotoneMail } from 'react-icons/ai'

const TopBar = () => {
  return (
    <div className='topbar'>
      <ul>
        <li>
          <a className='flex flex-row gap-0.5' href='tel:+995322997593'>
            <AiFillPhone style={{ marginRight: '5px', fontSize: '16px' }} /> (+995 32) 299-75-93
          </a>
        </li>
        <li className='flex flex-col gap-0.5'>
          <a className='flex flex-row gap-0.5' href='mailto:bulletin@science.org.ge'>
            <AiTwotoneMail style={{ marginRight: '5px', fontSize: '16px' }} />{' '}
            bulletin@science.org.ge
          </a>
          <a className='flex flex-row gap-0.5' href='mailto:bull.gnas@gmail.com'>
            <AiTwotoneMail style={{ marginRight: '5px', fontSize: '16px' }} /> bull.gnas@gmail.com
          </a>
        </li>
      </ul>
    </div>
  )
}

export default TopBar
